import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs';

@Injectable()
export class DataPassingService {

    private subject: Subject<string> = new Subject<string>();
    private appear: Subject<string> = new Subject<string>();
    private notificationIcon = new Subject<any>();

    /* Message */
    setMessage(data: any): void {
        this.subject.next(data);
    }

    getMessage(): Observable<string> {
        return this.subject.asObservable();
    }

    /* Apperance */
    setApperance(data: any): void {
        this.appear.next(data);
    }

    getApperance(): Observable<string> {
        return this.appear.asObservable();
    }

    /* Apperance */
    setNotificationIcon(data: any): void {
        this.notificationIcon.next(data);
    }

    getNotificationIcon(): Observable<string> {
        return this.notificationIcon.asObservable();
    }

}